import { useTranslation } from "react-i18next";
import edit from "./assets/pen-to-square-solid.svg";
import { PackingSlipModel } from "../../../dailyPlanning/domain/models/packingSlipModel";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { useEffect, useState } from "react";
import { updatePackingSlip } from "../../infrastructure/redux/PackingSlipThunks";

export const PackingSlipTableCommentRow = () => {
  const { t } = useTranslation("common");

  const dispatch = useAppDispatch();

  const model = useAppSelector((state) => state.crudMutate)
    .model as PackingSlipModel;

  const [isEdit, setIsEdit] = useState(false);

  const [comment, setComment] = useState("");

  useEffect(() => {
    setComment(model.comment ?? "");
  }, [model]);

  return (
    <tr className="packing-slip-comment">
      <td className="packing-slip-comment__label">{t("Comments")}:</td>
      <td className="packing-slip-comment__value">
        {isEdit ? (
          <>
            <textarea
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
              }}
              rows={3}
              className="form-control"
            />
            <div className="d-flex justify-content-end mt-2 gap-2">
              <button
                className="btn btn-light btn-sm"
                onClick={() => {
                  setComment(model.comment ?? "");
                  setIsEdit(false);
                }}
              >
                {t("cancel")}
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setIsEdit(false);

                  void dispatch(
                    updatePackingSlip({
                      id: parseInt(model.id),
                      data: {
                        comment: comment,
                      },
                      mutation: "upsertPackingSlip",
                    }),
                  );
                }}
              >
                {t("Save")}
              </button>
            </div>
          </>
        ) : (
          model.comment
        )}
      </td>
      {!isEdit && (
        <td className="packing-slip-comment__edit">
          <button onClick={() => setIsEdit(true)}>
            <img src={edit} alt={t("Edit")} width={16} />
          </button>
        </td>
      )}
    </tr>
  );
};
